/* eslint formatjs/no-literal-string-in-jsx: "error" */
import { ReimbursementsListDeductibleString } from "#/components/views/reimbursements/reimbursementsList/reimbursement-status-lists/ReimbursementsListDeductibleString"
import React, { FC } from "react"
import { Reimbursement } from "#/types/reimbursement"
import { FormattedMessage, useIntl } from "react-intl"
import moment from "moment"
import { useGetFundsAdministration } from "#/components/bank-details/hooks/useGetFundsAdministration"
import { ExpenseType } from "#/utils/ExpenseType"

type ReimbursementsListPaidExpenseStateProps = {
  reimbursement: Reimbursement
}

const ReimbursementsListPaidExpenseState: FC<ReimbursementsListPaidExpenseStateProps> = ({
  reimbursement
}: ReimbursementsListPaidExpenseStateProps) => {
  const intl = useIntl()
  const formattedDate = intl.formatDate(moment(reimbursement.paidDatetime).toDate(), {
    month: "short",
    day: "2-digit"
  })
  const fundsAdministration = useGetFundsAdministration()
  const isBankInfoEnabled = fundsAdministration?.data?.isBankInfoRequired
  const reimbursedOrReferred =
    reimbursement.expenseType === ExpenseType.OOP ? (
      isBankInfoEnabled ? (
        <FormattedMessage defaultMessage="Reimbursed on {formattedDate}" values={{ formattedDate }} />
      ) : (
        <FormattedMessage
          defaultMessage="Sent to benefit sponsor for reimbursement on {formattedDate}"
          values={{ formattedDate }}
        />
      )
    ) : (
      <FormattedMessage defaultMessage="Paid on {formattedDate}" values={{ formattedDate }} />
    )

  return (
    <>
      {reimbursement.amount > 0 && reimbursedOrReferred}
      <br />
      <ReimbursementsListDeductibleString reimbursement={reimbursement} />
    </>
  )
}

export { ReimbursementsListPaidExpenseState }
